// components/MainLayout.js
import React from 'react';
import { Box, BottomNavigation, BottomNavigationAction, Typography } from '@mui/material';
import { Whatshot, RecordVoiceOver, Settings } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

// const MainLayout = ({ children, user }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const getTabValue = () => {
//     if (location.pathname === '/all_apps') return 0;
//     if (location.pathname.startsWith('/blurt')) return 1;
//     if (location.pathname === '/settings') return 2;
//     return 1;
//   };

//   return (
//     <Box sx={{ 
//       minHeight: '100vh',
//       background: 'linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 50%, #45b7d1 100%)',
//       pb: 7   // 适应导航栏高度
//     }}>
//       {/* Logo */}
//       <Box sx={{ 
//         position: 'absolute', 
//         top: 20, 
//         left: 20, 
//         zIndex: 1000,
//         display: 'flex',
//         alignItems: 'center'
//       }}>
//         <Typography sx={{
//           fontFamily: '"Comic Sans MS", "Marker Felt", cursive',
//           fontSize: '1.5rem',
//           fontWeight: 'bold',
//           color: 'black',
//           textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
//           letterSpacing: '0.5px'
//         }}>
//           blurtyapp
//         </Typography>
//       </Box>
      
//       <Box sx={{ minHeight: '100vh' }}>
//         {children}
//       </Box>

//       {/* Beautiful Bottom Navigation - 调整高度和位置 */}
//       <BottomNavigation
//         value={getTabValue()}
//         onChange={(event, newValue) => {
//           const routes = ['/all_apps', '/blurt', '/settings'];
//           navigate(routes[newValue]);
//         }}
//         showLabels={true}  // 强制显示所有标签
//         sx={{ 
//           position: 'fixed', 
//           bottom: 0, 
//           left: 0, 
//           right: 0,
//           height: 70,  // 降低高度，更紧凑
//           background: 'rgba(255,255,255,0.95)',
//           backdropFilter: 'blur(20px)',
//           borderTop: '1px solid rgba(255,255,255,0.2)',
//           boxShadow: '0 -10px 30px rgba(0,0,0,0.1)',
//           '& .MuiBottomNavigationAction-root': {
//             color: '#9ca3af',
//             minWidth: 'auto',
//             paddingTop: '6px',  // 减少顶部padding
//             paddingBottom: '6px',  // 减少底部padding
//             '&.Mui-selected': {
//               color: '#667eea',
//               '& .MuiBottomNavigationAction-label': {
//                 fontSize: '0.75rem',
//                 fontWeight: '600',
//                 opacity: 1  // 确保选中状态文字可见
//               }
//             },
//             '& .MuiSvgIcon-root': {
//               fontSize: '24px',
//               transition: 'all 0.3s ease',
//               marginBottom: '4px'  // 图标和文字之间的间距
//             },
//             '&.Mui-selected .MuiSvgIcon-root': {
//               fontSize: '24px',  // 选中状态图标稍大
//               transform: 'translateY(-1px)'  // 减少上移距离
//             },
//             '& .MuiBottomNavigationAction-label': {
//               fontSize: '0.65rem',
//               fontWeight: '500',
//               transition: 'all 0.3s ease',
//               opacity: 1,  // 强制显示文字
//               transform: 'none'  // 确保文字不被隐藏
//             }
//           }
//         }}
//       >
//         <BottomNavigationAction 
//           label="trending"
//           icon={<Whatshot />} 
//           sx={{
//             '&.Mui-selected': {
//               '& .MuiSvgIcon-root': {
//                 color: '#667eea'
//               }
//             }
//           }}
//         />
//         <BottomNavigationAction 
//           label="blurt" 
//           icon={<RecordVoiceOver />}
//           sx={{
//             '&.Mui-selected': {
//               '& .MuiSvgIcon-root': {
//                 color: '#667eea'
//               }
//             }
//           }}
//         />
//         <BottomNavigationAction 
//           label="settings" 
//           icon={<Settings />}
//           sx={{
//             '&.Mui-selected': {
//               '& .MuiSvgIcon-root': {
//                 color: '#667eea'
//               }
//             }
//           }}
//         />
//       </BottomNavigation>
//     </Box>
//   );
// };


const MainLayout = ({ children }) => {
  return <>{children}</>
}

export default MainLayout;